/**
 * NepaliDateHelper.js
 * Comprehensive Bikram Sambat (BS) <-> Anno Domini (AD) conversion engine.
 * Covers Bikram Sambat years 2000 BS to 2090 BS with zero external dependencies.
 * Compliant with Nepal Government / Inland Revenue Department (IRD) fiscal year conventions.
 */

// Days in each month of Bikram Sambat years from 2000 BS to 2090 BS (12 months per year: Baisakh to Chaitra)
const BS_MONTH_DAYS = {
  2000: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2001: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2002: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  2003: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  2004: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2005: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2006: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  2007: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  2008: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
  2009: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2010: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  2011: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  2012: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
  2013: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2014: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  2015: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  2016: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
  2017: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2018: [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  2019: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2020: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2021: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2022: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2023: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2024: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2025: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2026: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2027: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2028: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2029: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2030: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2031: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2032: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2033: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2034: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2035: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2036: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2037: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2038: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2039: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2040: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2041: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2042: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2043: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2044: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2045: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2046: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2047: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2048: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2049: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2050: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2051: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2052: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2053: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2054: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2055: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2056: [31, 31, 32, 31, 32, 30, 30, 30, 29, 29, 30, 31],
  2057: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2058: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2059: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2060: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2061: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2062: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2063: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2064: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2065: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2066: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2067: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2068: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2069: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2070: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2071: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2072: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2073: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2074: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2075: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2076: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2077: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2078: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  2079: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  2080: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  2081: [31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 29, 30],
  2082: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
  2083: [31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
  2084: [31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
  2085: [31, 32, 31, 32, 30, 31, 30, 30, 29, 30, 30, 30],
  2086: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
  2087: [31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
  2088: [30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30],
  2089: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
  2090: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30]
};

// Anchor: 2000-01-01 BS = 1943-04-14 AD (Wednesday)
const START_YEAR_BS = 2000;
const START_DATE_AD = new Date(Date.UTC(1943, 3, 14)); // April 14, 1943 UTC

export const NEPALI_MONTHS = [
  { id: 1, name: "Baisakh", np: "बैशाख", short: "Bai" },
  { id: 2, name: "Jestha", np: "जेठ", short: "Jes" },
  { id: 3, name: "Ashadh", np: "असार", short: "Ash" },
  { id: 4, name: "Shrawan", np: "श्रावण", short: "Shr" },
  { id: 5, name: "Bhadra", np: "भाद्र", short: "Bha" },
  { id: 6, name: "Ashwin", np: "असोज", short: "Asw" },
  { id: 7, name: "Kartik", np: "कार्तिक", short: "Kar" },
  { id: 8, name: "Mangsir", np: "मंसिर", short: "Man" },
  { id: 9, name: "Poush", np: "पौष", short: "Pou" },
  { id: 10, name: "Magh", np: "माघ", short: "Mag" },
  { id: 11, name: "Falgun", np: "फाल्गुन", short: "Fal" },
  { id: 12, name: "Chaitra", np: "चैत", short: "Cha" }
];

/**
 * Converts AD Date (Date object or string YYYY-MM-DD) to Bikram Sambat (BS).
 * @param {Date|string} adDate 
 * @returns {{ year: number, month: number, day: number, bsDate: string, monthName: string, fiscalYear: string }}
 */
export function adToBs(adDate) {
  if (!adDate) return null;
  const d = typeof adDate === "string" ? new Date(adDate) : new Date(adDate.getTime());
  if (isNaN(d.getTime())) return null;

  // Difference in days between target AD date and anchor AD date
  const targetUtc = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
  const anchorUtc = START_DATE_AD.getTime();
  let diffDays = Math.round((targetUtc - anchorUtc) / (24 * 60 * 60 * 1000));

  if (diffDays < 0) {
    return { year: 2000, month: 1, day: 1, bsDate: "2000-01-01", monthName: "Baisakh", fiscalYear: "1999/00" };
  }

  let bsYear = START_YEAR_BS;
  let bsMonth = 1;
  let bsDay = 1;

  while (diffDays > 0) {
    const daysInYear = (BS_MONTH_DAYS[bsYear] || [31,31,31,31,31,31,30,30,30,30,30,30]).reduce((a, b) => a + b, 0);
    if (diffDays >= daysInYear && BS_MONTH_DAYS[bsYear + 1]) {
      diffDays -= daysInYear;
      bsYear++;
    } else {
      const monthDays = BS_MONTH_DAYS[bsYear] || [31,31,31,31,31,31,30,30,30,30,30,30];
      for (let m = 0; m < 12; m++) {
        const daysInMonth = monthDays[m];
        if (diffDays >= daysInMonth) {
          diffDays -= daysInMonth;
        } else {
          bsMonth = m + 1;
          bsDay = diffDays + 1;
          diffDays = 0;
          break;
        }
      }
      break;
    }
  }

  const mm = String(bsMonth).padStart(2, "0");
  const dd = String(bsDay).padStart(2, "0");
  const bsDate = `${bsYear}-${mm}-${dd}`;
  const monthName = NEPALI_MONTHS[bsMonth - 1]?.name || "Baisakh";
  const fiscalYear = getFiscalYearFromBs(bsYear, bsMonth);

  return { year: bsYear, month: bsMonth, day: bsDay, bsDate, monthName, fiscalYear };
}

/**
 * Converts Bikram Sambat Date (year, month, day) to AD Date.
 * @param {number} bsYear 
 * @param {number} bsMonth (1-12)
 * @param {number} bsDay (1-32)
 * @returns {Date}
 */
export function bsToAd(bsYear, bsMonth, bsDay) {
  let days = 0;
  for (let y = START_YEAR_BS; y < bsYear; y++) {
    const mDays = BS_MONTH_DAYS[y] || [31,31,31,31,31,31,30,30,30,30,30,30];
    days += mDays.reduce((a, b) => a + b, 0);
  }

  const curMonthDays = BS_MONTH_DAYS[bsYear] || [31,31,31,31,31,31,30,30,30,30,30,30];
  for (let m = 1; m < bsMonth; m++) {
    days += curMonthDays[m - 1];
  }
  days += (bsDay - 1);

  const targetUtc = START_DATE_AD.getTime() + days * 24 * 60 * 60 * 1000;
  return new Date(targetUtc);
}

/**
 * Returns Nepal Fiscal Year from BS Year and BS Month.
 * In Nepal, the fiscal year starts on Shrawan 1 (Month 4) and ends on Ashadh end (Month 3).
 * Example:
 *   Month 4 (Shrawan) of 2081 -> Fiscal Year "2081/82"
 *   Month 3 (Ashadh) of 2081  -> Fiscal Year "2080/81"
 * @param {number} bsYear 
 * @param {number} bsMonth (1-12)
 * @returns {string} e.g. "2081/82"
 */
export function getFiscalYearFromBs(bsYear, bsMonth) {
  if (bsMonth >= 4) {
    const nextYearShort = String(bsYear + 1).slice(-2);
    return `${bsYear}/${nextYearShort}`;
  } else {
    const curYearShort = String(bsYear).slice(-2);
    return `${bsYear - 1}/${curYearShort}`;
  }
}

/**
 * Returns start and end AD dates for a given Nepali month and fiscal year.
 * @param {string} fiscalYear e.g. "2081/82"
 * @param {number} nepaliMonth (1=Baisakh to 12=Chaitra)
 * @returns {{ fromAd: string, toAd: string, bsYear: number, monthName: string }}
 */
export function getMonthDateRange(fiscalYear, nepaliMonth) {
  const parts = String(fiscalYear).split("/");
  const startBsYear = parseInt(parts[0], 10);
  // Months 4-12 belong to startBsYear. Months 1-3 belong to startBsYear + 1.
  const bsYear = nepaliMonth >= 4 ? startBsYear : startBsYear + 1;
  const monthDays = (BS_MONTH_DAYS[bsYear] || [31,31,31,31,31,31,30,30,30,30,30,30])[nepaliMonth - 1] || 30;

  const startAd = bsToAd(bsYear, nepaliMonth, 1);
  const endAd = bsToAd(bsYear, nepaliMonth, monthDays);

  const fromAd = startAd.toISOString().substring(0, 10);
  const toAd = endAd.toISOString().substring(0, 10);
  const monthName = NEPALI_MONTHS[nepaliMonth - 1]?.name || "";

  return { fromAd, toAd, bsYear, monthName, totalDays: monthDays };
}

/**
 * Returns current BS Date and details.
 */
export function getCurrentBsDate() {
  return adToBs(new Date());
}

/**
 * Returns list of recent Nepali Fiscal Years for dropdowns (e.g. 2083/84, 2082/83, 2081/82, 2080/81).
 */
export function getAvailableFiscalYears() {
  const cur = getCurrentBsDate();
  const curStart = parseInt(cur.fiscalYear.split("/")[0], 10);
  const list = [];
  for (let y = curStart + 1; y >= curStart - 3; y--) {
    const next = String(y + 1).slice(-2);
    list.push(`${y}/${next}`);
  }
  return list;
}

export default {
  NEPALI_MONTHS,
  adToBs,
  bsToAd,
  getFiscalYearFromBs,
  getMonthDateRange,
  getCurrentBsDate,
  getAvailableFiscalYears
};
